import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const EmployTypeService = {
  getEmployTypeDetail(obj) {
    return httpClient.post(endPoints.getEmployTypeDetail, obj);
  },
  getAllEmployTypes(obj) {
    return httpClient.post(endPoints.getEmployTypes, obj);
  },
  getAllEmployTypeByPagination(obj) {
    return httpClient.post(endPoints.getAllEmployTypeByPagination, obj);
  },
  addEmployType(obj) {
    return httpClient.post(endPoints.addEmployType, obj);
  },
  updateEmployType(obj) {
    return httpClient.post(endPoints.updateEmployType, obj);
  },
  deleteEmployType(obj) {
    return httpClient.post(endPoints.deleteEmployType, obj);
  },
};

export default EmployTypeService;



// WEBPACK FOOTER //
// ./src/service/EmployTypeService.js